import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { HEC_CONSTANTS } from "../../../app/utilities/constants";
import * as introJs from "intro.js/intro.js";
import { ConfirmationModalService } from "../shared-components/modal/confimation-modal/confirmation-modal.service";
import { MatSnackBar } from "@angular/material";
import { ConditionalErrorsModalService } from "../shared-components/modal/conditional-errors-modal/conditional-errors-modal.service";
import { FormSubmWarningModalService } from "../shared-components/modal/form-subm-warning-modal/form-subm-warning-modal.service";
import { PopupService } from "../shared-components/modal/popup/popup.service";
import { CommonHelper } from "../../../app/utilities/common.helper";

@Injectable({
    providedIn: 'root'
})
export class SharedService {
    private pcdAppId: any = null;


    public isDesfAdmin: BehaviorSubject<any> = new BehaviorSubject(null);
    introguide = introJs();
    constructor(private http: HttpClient, private confirmationModalService: ConfirmationModalService,
        public _snackBar: MatSnackBar, private conditionalErrorModalService: ConditionalErrorsModalService,
        private formSubmModalService: FormSubmWarningModalService, private popupModelService: PopupService) { }

    public uploadDocumentService(payload): Observable<any> {
        return this.http.post(environment.BASE_URL_COMMON + 'attachment/uploadDocument', payload)
    }

    public deleteDocumentService(payload): Observable<any> {
        return this.http.post(environment.BASE_URL_COMMON + 'attachment/deleteByDocumentId', payload)
    }

    public deleteDESFEducation(payload): Observable<any> {
        return this.http.post(environment.BASE_URL_DES + 'desf/deleteEducation', payload)
    }

    public getAttachementService(payload) {
        return this.http.post(environment.BASE_URL_COMMON + 'attachment/getAttachmentByDocumentId', payload)
    }

    public getDocumentService(payload): Observable<any> {
        return this.http.post(environment.BASE_URL_COMMON + 'attachment/getDocumentByAppIdAndAcronym', payload)
    }

    public getProfileDetails(id): Observable<any> {
        return this.http.get(environment.BASE_URL_COURSERA + 'coursera/applicant-details/' + id)
    }

    public isFocalPerson(): Observable<any> {
        return this.http.get(environment.BASE_URL_DAS + 'das/isForeignEmbassyFocalPerson');
    }

    public getCountryList(): Observable<any> {
        return this.http.get(environment.BASE_URL_COMMON + 'common/getCountryList')
    }

    public getAddressDetails(): Observable<any> {
        return this.http.get(environment.BASE_URL_PROFILE + '/profile/getAddresses')
    }

    public getProvincesByCountryId(id): Observable<any> {
        return this.http.get(environment.BASE_URL_COMMON + 'common/getProvinces/' + id)
    }

    public getCountriesDialingCode(): Observable<any> {
        return this.http.get(environment.BASE_URL_COMMON + 'common/getCountryDialingCodes')
    }

    public postSendMobileVerificationCode(payload): Observable<any> {
        return this.http.post(environment.BASE_URL_PROFILE + 'auth/sendCode', payload)
    }

    public postSendMobileVerificationOTP(appid): Observable<any> {
        return this.http.get(environment.BASE_URL_DAS + 'das/sendOTP/' + appid)
    }

    public postSendMobileVerificationOTPForDES(appid, acronym): Observable<any> {
        return this.http.get(environment.BASE_URL_DES + `${acronym}/sendOTP/` + appid)
    }

    public getContactDetails(): Observable<any> {
        return this.http.get(environment.BASE_URL_PROFILE + "profile/getContactDetails")
    }

    public postSendEmailVerificationCode(payload): Observable<any> {
        return this.http.post(environment.BASE_URL_PROFILE + 'auth/sendCode', payload)
    }

    public postVerificationCode(payload): Observable<any> {
        return this.http.post(environment.BASE_URL_PROFILE + 'auth/verifyCode', payload)
    }

    public getBlacklistedDomains(): Observable<any> {
        return this.http.get('./assets/json/blacklist.json');
    }

    public login(payload, userLoginDetails): Observable<any> {
        let headers = new HttpHeaders();
        localStorage.setItem('login', JSON.stringify(payload))
        headers = headers.append('Authorization', 'Basic ' + btoa(payload.username + ":" + payload.password));
        headers = headers.append("X-Requested-With", "XMLHttpRequest");
        let httpOptions = { headers: headers, cache: false };
        return this.http.post(environment.BASE_URL_PROFILE + 'auth/login', userLoginDetails, httpOptions);
    }

    public getBatchesList(): Observable<any> {
        return this.http.get(environment.BASE_URL_HRD + 'rga/getRgaBatch');
    }

    public getGrantList(batchId): Observable<any> {
        return this.http.get(
            environment.BASE_URL_HRD + 'rga/getRgaGrantConfigByBatchId/' + batchId
        );
    }

    public openConditionalErrors(title?, msg?) {
        return this.conditionalErrorModalService
            .confirm(title || 'Title', msg || ['Message'])
            .then(res => {
                // window.scroll(0, 0);
            })
            .catch(err => {
                // window.scroll(0, 0);
            });
    }

    deletePanelDetails(panelId) {
        return this.http.get(
            environment.BASE_URL_HRD + 'tmMng/deleteRgaPanel/' + panelId
        );
    }

    public exportToExcelTeamManagementData(payload) {
        return this.http.post(
            environment.BASE_URL_COMMON_RGA +
            'cmn/reportGeneration/RND/RGMS_TeamManagement_Excel_Report/xls',
            payload
        );
    }

    public exportDASsampleFile() {
        return this.http.get(environment.BASE_URL_DAS + 'das/downloadExcel', { responseType: 'blob' })

    }


    public getCitiesByCountryId(countryId): Observable<any> {
        return this.http.get(environment.BASE_URL_COMMON + 'common/getCities/' + countryId)
    }

    public logoutUser() {
        return this.http.get(environment.BASE_URL_PROFILE + '/auth/logout')
    }

    public getUserProfilePicture(): Observable<any> {
        return this.http.get(environment.BASE_URL_PROFILE + 'profile/getProfilePicture')
    }

    public postUpdateProfilePicture(payload): Observable<any> {
        return this.http.post(environment.BASE_URL_PROFILE + "profile/uploadImage", payload)
    }

    public getPersonalDetails(): Observable<any> {
        return this.http.get(environment.BASE_URL_PROFILE + "profile/getPersonalDetails")
    }

    public updatePrimaryCellNumber(payload): Observable<any> {
        return this.http.post(environment.BASE_URL_PROFILE + 'auth/updatePrimaryContact', payload)
    }

    public updatePrimaryEmail(payload): Observable<any> {
        return this.http.post(environment.BASE_URL_PROFILE + 'auth/updatePrimaryEmail', payload)
    }

    public verifyOldPassword(payload): Observable<any> {
        return this.http.post(environment.BASE_URL_PROFILE + 'auth/verifyOldPassword', payload)
    }

    public verifyChangePasswordCode(payload): Observable<any> {
        return this.http.post(environment.BASE_URL_PROFILE + 'auth/verifyChangePasswordCode', payload)
    }

    public updatePassword(payload): Observable<any> {
        return this.http.post(environment.BASE_URL_PROFILE + 'auth/updatePassword', payload)
    }

    public getCountryByDialingCode(countryId, countryDialingCode): Observable<any> {
        return this.http.get(environment.BASE_URL_COMMON + 'common/getCountryByDialingCodeAndCountryCode/' + countryId + '/' + countryDialingCode)
    }


    public getDistrictsByCityId(cityId): Observable<any> {
        return this.http.get(environment.BASE_URL_COMMON + 'common/getDistrictByCityId/' + cityId)
    }

    public getPostalCodeByCityId(cityId): Observable<any> {
        return this.http.get(environment.BASE_URL_COMMON + 'common/getPostalCodeByCityId/' + cityId)
    }

    public saveAddress(payload): Observable<any> {
        return this.http.post(environment.BASE_URL_PROFILE + 'profile/saveAddress', payload)
    }

    public getEducationDetails(): Observable<any> {
        return this.http.get(environment.BASE_URL_PROFILE + "education/getEducationDetails")
    }

    public saveOrUpdateEducation(payload): Observable<any> {
        return this.http.post(environment.BASE_URL_PROFILE + 'education/updateEducationDetails', payload)
    }
    public saveOrUpdatePCDEducation(profileId, payload): Observable<any> {
        return this.http.post(environment.BASE_URL_PROFILE + 'education/updateEducationDetails/' + profileId, payload)
    }
    public getApplicationData(appId): Observable<any> {
        // Return API payload as-is so isQuestionnaireFilled (null/false/true/missing) drives questionnaire UX.
        // return this.http.get(environment.BASE_URL_DAS + 'das/getApplicationData/' + appId);
        return this.http.get(environment.BASE_URL_PCD + 'api/das/' + appId + '/das-app-details');    
    }

    public getProfileFormData(): Observable<any> {
        return this.http.get(environment.BASE_URL_DAS + 'das/getInitFormData')
    }

    public addNotification(payload): Observable<any> {
        return this.http.post(environment.BASE_URL_PROFILE + 'profile/addNewNotification', payload)
    }

    public getAllNotifications(page): Observable<any> {
        return this.http.get(environment.BASE_URL_PROFILE + 'profile/getAllNotifications/' + page)
    }

    public getAllNotificationsByAcronyms(page, data): Observable<any> {
        return this.http.post(environment.BASE_URL_PROFILE + 'profile/getAllNotificationsByAcronyms/' + page, data)
    }

    public getUnReadNotifications(data): Observable<any> {
        return this.http.post(environment.BASE_URL_PROFILE + 'profile/getUnReadNotifications', data)
    }

    public updateNotification(payload): Observable<any> {
        return this.http.post(environment.BASE_URL_PROFILE + 'profile/updateNotification', payload)
    }

    downloadPdf(payload, formName): Observable<any> {
        return this.http.post(environment.BASE_URL_COMMON + 'misc/reportGeneration/DAS/' + formName + '/pdf', payload);
    }

    public showPdf(formName, base64) {
        const linkSource = 'data:application/pdf;base64,' + base64;
        const downloadLink = document.createElement("a");
        const fileName = formName + ".pdf";

        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    }

    public dateConverter(d) {
        let date: any;
        let month: any;
        if (d.getDate().toString().length < 2) {
            date = '0' + d.getDate().toString()
        } else {
            date = d.getDate().toString()
        }
        if ((d.getMonth() + 1).toString().length < 2) {
            month = '0' + (d.getMonth() + 1).toString()
        } else {
            month = (d.getMonth() + 1).toString()
        }
        const day = d.getFullYear().toString() + "-" + month + "-" + date;
        return day
    }

    public getDate(date): any {
        date = new Date(date)
        let month: any;
        let dated: any;
        if (date.getDate().toString().length < 2) {
            dated = '0' + date.getDate().toString()
        } else {
            dated = date.getDate().toString()
        }
        if ((date.getMonth() + 1).toString().length < 2) {
            month = '0' + (date.getMonth() + 1).toString()
        } else {
            month = (date.getMonth() + 1).toString()
        }
        let convertedDate = date.getFullYear() + "-" + month + "-" + dated;
        return convertedDate
    }

    checkAdminRole(roleList: any[]): any {
        // const isRoleFound = roleList.some(role => {
        //  return (role.role == HEC_CONSTANTS.UserRoles.ASSISTANT || role.role == HEC_CONSTANTS.UserRoles.FINANCE
        //      || role.role == HEC_CONSTANTS.UserRoles.AD || role.role == HEC_CONSTANTS.UserRoles.DD
        //      || role.role == HEC_CONSTANTS.UserRoles.DIR || role.role == HEC_CONSTANTS.UserRoles.ED || role.role == HEC_CONSTANTS.UserRoles.COURIER_ADMIN ||
        //     role.role == HEC_CONSTANTS.UserRoles.DG || role.role == HEC_CONSTANTS.UserRoles.CHAIRMAN || role.role == HEC_CONSTANTS.UserRoles.MEMBER)
        // });
        const isRoleFound = roleList.some(role => {
            const roleValue = role.role || role[1];
            return (roleValue == HEC_CONSTANTS.UserRoles.ASSISTANT || roleValue == HEC_CONSTANTS.UserRoles.FINANCE
                || roleValue == HEC_CONSTANTS.UserRoles.AD || roleValue == HEC_CONSTANTS.UserRoles.DD
                || roleValue == HEC_CONSTANTS.UserRoles.ADMIN_VERIFICATION || roleValue == HEC_CONSTANTS.UserRoles.LOCAL_ADMIN_VERIFICATION
                || roleValue == HEC_CONSTANTS.UserRoles.DIR || roleValue == HEC_CONSTANTS.UserRoles.ED || roleValue == HEC_CONSTANTS.UserRoles.COURIER_ADMIN || roleValue == HEC_CONSTANTS.UserRoles.Das_Scheduler_Admin || roleValue == HEC_CONSTANTS.UserRoles.DBV_ADMIN ||
                roleValue == HEC_CONSTANTS.UserRoles.DG || roleValue == HEC_CONSTANTS.UserRoles.CHAIRMAN || roleValue == HEC_CONSTANTS.UserRoles.MEMBER || roleValue == HEC_CONSTANTS.UserRoles.COURSERA_FOCAL_PERSON || roleValue == HEC_CONSTANTS.UserRoles.COURSERA_HEC_PERSON || roleValue == HEC_CONSTANTS.UserRoles.DAS_STMAP_ADMIN)
        });

        if (isRoleFound) {
            const rolesAvailable = [];
            roleList.filter(role => {
                const processAcronym = role.processAcronym || role[0];
                const roleValue = role.role || role[1];
                if (processAcronym == 'DAS' || processAcronym == 'DES' || processAcronym == 'DESF')
                    rolesAvailable.push(roleValue)
            });
            return { isRoleFound: isRoleFound, roleAvailable: rolesAvailable }
        } else {
            return false;
        }
    }

    checkLetterUpdateAdminCategory(adminTypeList: any[]): any {
        console.log(adminTypeList)
        let AcronymList = []
        adminTypeList.map(acronym => {
            AcronymList.push(acronym[1]);
        })

        console.log(AcronymList)
        if (AcronymList.length > 0) {
            if (AcronymList.includes('DD') || AcronymList.includes('AD') || AcronymList.includes('DIR')
            )
                return true

            else
                return false
        } else {
            return false;
        }


    }

    checkAdminType(adminTypeList: any[]): any {
        let AcronymList = []
        adminTypeList.map(acronym => {
            AcronymList.push(acronym.processAcronym || acronym[0]);
        })
        console.log(AcronymList);
        if (AcronymList.length > 0) {
			if (AcronymList.includes('DAS') && AcronymList.includes('COURSERA')) {
				return 'DAS-COURSERA'
			}
            else if (AcronymList.includes('DAS')) {
                if (AcronymList.includes('DESF') && !AcronymList.includes('DES')) {
                    return 'DESF'
                } else {
                    return 'DAS'
                }
            }
            else if (AcronymList.includes('COURSERA') && !AcronymList.includes('PCD')) {
                return 'COURSERA'
            }
            else if (AcronymList.includes('PCD') && !AcronymList.includes('COURSERA')) {
                return 'PCD'
            }
            else if (AcronymList.includes('PCD') && AcronymList.includes('COURSERA')) {
                return 'PCD-COURSERA'
            }
            else if (AcronymList.includes('DES') && !AcronymList.includes('DESF')) {
                return 'DES'
            } else if (AcronymList.includes('DESF') && !AcronymList.includes('DES')) {
                return 'DESF'
            }
            else {
                let adminTypes = ['DESF', 'DES']
                let result = adminTypes.every(i => AcronymList.includes(i));
                return result ? 'ALL' : 'USER';
            }
        } else {
            return 'USER';
        }

        // adminTypeList.every( (val, i, arr) => val === arr[0] )
        // return adminTypeList.every(role => {
        //   if(role[0] == HEC_CONSTANTS.AdminTypes.DAS){
        //     return 'DAS'
        //   }else if(role[0] == HEC_CONSTANTS.AdminTypes.DES){
        //     return 'DES'
        //   }else if(role[0] == HEC_CONSTANTS.AdminTypes.DAS && role[0] == HEC_CONSTANTS.AdminTypes.DAS){
        //     return 'ALL'
        //   }
        // });
    }

    checkAdminCategory(adminTypeList: any[]): any {
        console.log(adminTypeList)
        let AcronymList = []
        adminTypeList.map(acronym => {
            AcronymList.push(acronym.role || acronym[1]);
        })
        if (AcronymList.length > 0) {
            if (AcronymList.includes('AD')) {
                return 'AD'
            } else if (AcronymList.includes('DD')) {
                return 'DD'
            }
            else if (AcronymList.includes('ADMIN_VERIFICATION')) {
                return 'ADV'
            } else if (AcronymList.includes('LOCAL_ADMIN_VERIFICATION')) {
                return 'ADV'
            }
            else if (AcronymList.includes('DIR')) {
                return 'DIR'
            } else if (AcronymList.includes('ASSISTANT')) {
                return 'ASSISTANT'
            }
            else if (AcronymList.includes('DAS_BLACKLISTED_VERIFICATION_PERSON')) {
                return 'DBV_ADMIN'
            }
            else if (AcronymList.includes('Das Scheduler Admin')) {
                return 'SCH_ADMIN'
            }
            else if (AcronymList.includes('Das_Stamp_Admin')) {
                return 'STAMP_ADMIN'
            }

            else if (AcronymList.includes('ADMIN')) {
                return 'HEC_COURSERA_ADMIN'
            }
            // ─── ADD NEW DESF / DES ROLE CATEGORIES HERE ──────────────────────────
            // Example: else if (AcronymList.includes('Hdvi_Officer')) { return 'HDVI'; }
            // Then handle 'HDVI' category inside applyDesDesfAsideMenus() in
            // aside-left.component.ts (same pattern as the 'AD', 'ASSISTANT' blocks).
            // ──────────────────────────────────────────────────────────────────────
            else {
                return 'TA';
            }
        } else {
            return 'USER';
        }

        // adminTypeList.every( (val, i, arr) => val === arr[0] )
        // return adminTypeList.every(role => {
        //   if(role[0] == HEC_CONSTANTS.AdminTypes.DAS){
        //     return 'DAS'
        //   }else if(role[0] == HEC_CONSTANTS.AdminTypes.DES){
        //     return 'DES'
        //   }else if(role[0] == HEC_CONSTANTS.AdminTypes.DAS && role[0] == HEC_CONSTANTS.AdminTypes.DAS){
        //     return 'ALL'
        //   }
        // });
    }

    checkDGCategory(adminTypeList: any[]): any {
        console.log(adminTypeList)
        let AcronymList = []
        adminTypeList.map(acronym => {
            AcronymList.push(acronym[1]);
        })

        console.log(AcronymList)
        if (AcronymList.length > 0) {
            if (AcronymList.includes('DG'))
                return true

            else
                return false
        } else {
            return false;
        }


    }




    // checkAdminType(adminTypeList: any[]): any {
    //   let AcronymList = []
    //   adminTypeList.map(acronym =>{
    //     AcronymList.push(acronym[0]);
    //   })
    //   if(AcronymList.length > 0){
    //   if(AcronymList.includes('DAS')){
    //     return 'DAS'
    //   }else if(AcronymList.includes('DES')){
    //     return 'DES'
    //   }else{
    //     let adminTypes = ['DAS','DES']
    //     let result = adminTypes.every(i => AcronymList.includes(i));
    //     return result ? 'ALL':'USER';
    //   }}else{
    //     return 'USER';
    //   }

    //   // adminTypeList.every( (val, i, arr) => val === arr[0] )
    //  // return adminTypeList.every(role => {
    //   //   if(role[0] == HEC_CONSTANTS.AdminTypes.DAS){
    //   //     return 'DAS'
    //   //   }else if(role[0] == HEC_CONSTANTS.AdminTypes.DES){
    //   //     return 'DES'
    //   //   }else if(role[0] == HEC_CONSTANTS.AdminTypes.DAS && role[0] == HEC_CONSTANTS.AdminTypes.DAS){
    //   //     return 'ALL'
    //   //   }
    //  // });
    // }

    setDesfAdmin(value) {
        this.isDesfAdmin.next(value);
    }

    getDesfAdmin(): Observable<any> {
        return this.isDesfAdmin.asObservable();
    }

    getIntroJs() {
        return this.introguide;
    }

    public openCancelConfirmationDialog(title?, msg?, previewReport?) {
        return this.confirmationModalService
            .confirm(
                title || 'Please confirm',
                msg || 'Do you really want to reset form?',
                previewReport || false
            )
            .then(confirmed => {
                // if (confirmed == true) {
                //   return true;
                // } else {
                //   return false;
                // }
                return confirmed;
            })
            .catch(e => { });
    }

    public showError(message, action, styleType) {
        this._snackBar.open(message, '', {
            duration: 3500,
            panelClass: [styleType]
        });
    }
    public showSuccess(message, action, styleType) {
        this._snackBar.open(message, '', {
            duration: 3500,
            panelClass: [styleType]
        });
    }
    // --------------------rga----------------------

    public getPanelsListForTeamManagement(grantId) {
        let grantIdValue = grantId ? grantId : 0;
        return this.http.get(
            environment.BASE_URL_HRD +
            'tmMng/getRgaDisciplinaryCodeLabelValues/' +
            grantIdValue
        );
    }

    public getCategoryListForTeamManagement(panelId, panelMemberId?) {
        let memberId = panelMemberId ? panelMemberId : 0;
        return this.http.get(
            environment.BASE_URL_HRD + 'tmMng/getCategory/' + panelId + '/' + memberId
        );
    }

    public getMajorList() {
        return this.http.get(
            environment.BASE_URL_COMMON + 'cmn/getFirstAndSecondLevelSubjectList'
        );
    }

    public getInstituteList() {
        return this.http.get(
            environment.BASE_URL_HRD + 'tmMng/getRgaInstituteLabelValue'
        );
    }

    public getPanelMembersDropdown(assignmentCode, grantId, applicationId) {
        // console.log(assignmentCode)
        // console.log(grantId)
        return this.http.get(
            environment.BASE_URL_HRD +
            'rga/getPanelDetails/' +
            assignmentCode +
            '/' +
            grantId
        );
    }

    public getIsTaskDeligated(assignmentCode, applicationId) {
        return this.http.get(
            environment.BASE_URL_HRD +
            'rga/isTaskDeligated/' +
            assignmentCode +
            '/' +
            applicationId
        );
    }

    public getIsTaskDeligatedReviewForm(
        applicationId,
        stageCodeId,
        reviewStatus
    ) {
        return this.http.get(
            environment.BASE_URL_HRD +
            'rga/isTaskDeligated/' +
            applicationId +
            '/' +
            stageCodeId +
            '/' +
            reviewStatus
        );
    }
    public getBatchListByAssignmentType(assignmentCode): Observable<any> {
        return this.http.get(
            environment.BASE_URL_HRD + 'rga/getRgaBatchByAssigment/' + assignmentCode
        );
    }

    public getBatchListForStatus(assignmentCode): Observable<any> {
        return this.http.get(
            environment.BASE_URL_HRD +
            'rga/getRgaBatchForStatusByAssigment/' +
            assignmentCode
        );
    }

    public getAssignedProjectDetails(assignmentCode, grantId) {
        return this.http.get(
            environment.BASE_URL_HRD +
            'rga/getAssignedProjectDetails/' +
            assignmentCode +
            '/' +
            grantId
        );
    }

    public getAssignedProjectStatusDetails(assignmentCode, grantId) {
        return this.http.get(
            environment.BASE_URL_HRD +
            'rga/getAssignedProjectStatusDetails/' +
            assignmentCode +
            '/' +
            grantId
        );
    }

    public downloadReport(payload, formType?, fileType?) {
        return this.http.post(
            environment.BASE_URL_COMMON +
            'cmn/reportGeneration/RND/' +
            formType +
            '/' +
            fileType,
            payload
        );
    }

    public downloadReportInPdf(payload, formType?) {
        return this.http.post(
            environment.BASE_URL_COMMON +
            'cmn/reportGeneration/RND/' +
            formType +
            '/pdf',
            payload
        );
    }

    public getPanelEvaluationAndBudgetDetailsByApplicationId(
        applicationId,
        panelStageTypeCodeId
    ): Observable<any> {
        return this.http.get(
            environment.BASE_URL_HRD +
            'rga/getPanelEvaluationDetail/' +
            applicationId +
            '/' +
            panelStageTypeCodeId
        );
    }

    public getPanelEvaluationAndBudgetDetailsStatusPanelChair(
        projectAssignmentId,
        panelStageTypeCodeId
    ): Observable<any> {
        return this.http.get(
            environment.BASE_URL_HRD +
            'rga/getPanelEvaluationDetailByAssignmentId/' +
            projectAssignmentId +
            '/' +
            panelStageTypeCodeId
        );
    }

    public getJmpRecommendationAndComment(applicationId): Observable<any> {
        return this.http.get(
            environment.BASE_URL_HRD +
            'rga/getJmpRecommendationAndComment/' +
            applicationId
        );
    }


    public getProjectInformation(projectNumber, rgaGrantConfigId) {
        return this.http.get(
            environment.BASE_URL_HRD +
            'rga/getRgaProjectDetails/' +
            projectNumber +
            '/' +
            rgaGrantConfigId
        );
    }

    saveNewMemberDetails(payload, isValuePresentInDisciplinary?) {
        payload.panelTypeCodeId = +localStorage.getItem('TEAM_CODE');
        if (payload.isPanelUpdated) {
            delete payload.isPanelUpdated;
        }

        for (let i = 0; i < payload.rgaRoleViewDtoList.length; i++) {
            if (payload.rgaRoleViewDtoList[i].panelId) {
                payload.disciplinaryPanelId = payload.rgaRoleViewDtoList[0].panelId;
                delete payload.rgaRoleViewDtoList[i].panelId;
            } else {
                if (payload.rgaRoleViewDtoList[i].panelId == null) {
                    delete payload.rgaRoleViewDtoList[i].panelId;
                }
            }
        }

        if (payload.disciplinaryPanelId) {
            payload.addDisciplinaryPanel = true;
        } else {
            payload.addDisciplinaryPanel = false;
        }

        // if(!isValuePresentInDisciplinary){
        //   payload.panelTypeCodeId = 209204
        //   payload.panelId = payload.rgaRoleViewDtoList[0].panelId,
        //   payload.panelName = payload.rgaRoleViewDtoList[0].panelName
        // }
        return this.http.post(
            environment.BASE_URL_HRD + 'tmMng/saveManagementDetail',
            payload
        );
    }

    saveNewMemberDetailsJMP(payload) {
        // payload.panelTypeCodeId = +localStorage.getItem("TEAM_CODE")
        if (payload.isPanelUpdated) {
            delete payload.isPanelUpdated;
        }

        for (let i = 0; i < payload.rgaRoleViewDtoList.length; i++) {
            if (payload.rgaRoleViewDtoList[i].panelId) {
                payload.disciplinaryPanelId = payload.rgaRoleViewDtoList[0].panelId;
                delete payload.rgaRoleViewDtoList[i].panelId;
            } else {
                if (payload.rgaRoleViewDtoList[i].panelId == null) {
                    delete payload.rgaRoleViewDtoList[i].panelId;
                }
            }
        }

        if (payload.disciplinaryPanelId) {
            payload.addDisciplinaryPanel = true;
        } else {
            payload.addDisciplinaryPanel = false;
        }

        return this.http.post(
            environment.BASE_URL_HRD + 'tmMng/saveJmpPanelMembers',
            payload
        );
    }

    saveNewMemberDetailsSteeringCommittee(payload) {
        // payload.panelTypeCodeId = +localStorage.getItem("TEAM_CODE")
        if (payload.isPanelUpdated) {
            delete payload.isPanelUpdated;
        }

        for (let i = 0; i < payload.rgaRoleViewDtoList.length; i++) {
            if (payload.rgaRoleViewDtoList[i].panelId) {
                payload.disciplinaryPanelId = payload.rgaRoleViewDtoList[0].panelId;
                delete payload.rgaRoleViewDtoList[i].panelId;
            } else {
                if (payload.rgaRoleViewDtoList[i].panelId == null) {
                    delete payload.rgaRoleViewDtoList[i].panelId;
                }
            }
        }

        if (payload.disciplinaryPanelId) {
            payload.addDisciplinaryPanel = true;
        } else {
            payload.addDisciplinaryPanel = false;
        }

        return this.http.post(
            environment.BASE_URL_HRD + 'tmMng/saveSteeringCommitteePanelMembers',
            payload
        );
    }

    saveNewMemberDetailsHLEP(payload) {
        // payload.panelTypeCodeId = +localStorage.getItem("TEAM_CODE")
        if (payload.isPanelUpdated) {
            delete payload.isPanelUpdated;
        }

        for (let i = 0; i < payload.rgaRoleViewDtoList.length; i++) {
            if (payload.rgaRoleViewDtoList[i].panelId) {
                payload.disciplinaryPanelId = payload.rgaRoleViewDtoList[0].panelId;
                delete payload.rgaRoleViewDtoList[i].panelId;
            } else {
                if (payload.rgaRoleViewDtoList[i].panelId == null) {
                    delete payload.rgaRoleViewDtoList[i].panelId;
                }
            }
        }

        if (payload.disciplinaryPanelId) {
            payload.addDisciplinaryPanel = true;
        } else {
            payload.addDisciplinaryPanel = false;
        }

        return this.http.post(
            environment.BASE_URL_HRD + 'tmMng/saveHlepPanelMembers',
            payload
        );
    }

    searchProfileCasesTypeTwo(payload, pageState) {
        if (pageState) {
            if (pageState == 'JMP') {
                return this.saveNewMemberDetailsJMP(payload);
            } else if (pageState == 'HLEP') {
                return this.saveNewMemberDetailsHLEP(payload);
            } else if (pageState == 'Steering Committee') {
                return this.saveNewMemberDetailsSteeringCommittee(payload);
            } else {
                return null;
            }
        }
    }

    updateMajorMinorSubjectsInvitationAccepted(payload, pageState) {
        if (pageState) {
            if (pageState == 'JMP') {
                return this.saveNewMemberDetailsJMP(payload);
            } else if (pageState == 'HLEP') {
                return this.saveNewMemberDetailsHLEP(payload);
            } else if (pageState == 'Steering Committee') {
                return this.saveNewMemberDetailsSteeringCommittee(payload);
            } else {
                return null;
            }
        }
    }

    updateMajorMinorSubjectsInvitationNotAccepted(payload, pageState) {
        if (pageState) {
            if (pageState == 'JMP') {
                return this.addAndInviteJMPMember(payload);
            } else if (pageState == 'HLEP') {
                return this.addAndInviteHLEPMember(payload);
            } else if (pageState == 'Steering Committee') {
                return this.addAndInviteSteeringCommitteeMember(payload);
            } else {
                return null;
            }
        }
    }

    addAndInviteMember(payload) {
        payload.panelTypeCodeId = +localStorage.getItem('TEAM_CODE');
        if (payload.rgaRoleViewDtoList[0].panelId) {
            payload.disciplinaryPanelId = payload.rgaRoleViewDtoList[0].panelId;
            delete payload.rgaRoleViewDtoList[0].panelId;
        }
        if (!payload.disciplinaryPanelId) {
            delete payload.rgaRoleViewDtoList[0].panelId;
        }

        return this.http.post(
            environment.BASE_URL_HRD + 'tmMng/inviteUser',
            payload
        );
    }

    addAndInviteJMPMember(payload) {
        // payload.panelTypeCodeId = +localStorage.getItem("TEAM_CODE")
        if (payload.rgaRoleViewDtoList[0].panelId) {
            payload.disciplinaryPanelId = payload.rgaRoleViewDtoList[0].panelId;
            delete payload.rgaRoleViewDtoList[0].panelId;
        }
        if (!payload.disciplinaryPanelId) {
            delete payload.rgaRoleViewDtoList[0].panelId;
        }

        return this.http.post(
            environment.BASE_URL_HRD + 'tmMng/inviteJmpUser',
            payload
        );
    }

    addAndInviteSteeringCommitteeMember(payload) {
        // payload.panelTypeCodeId = +localStorage.getItem("TEAM_CODE")
        if (payload.rgaRoleViewDtoList[0].panelId) {
            payload.disciplinaryPanelId = payload.rgaRoleViewDtoList[0].panelId;
            delete payload.rgaRoleViewDtoList[0].panelId;
        }
        if (!payload.disciplinaryPanelId) {
            delete payload.rgaRoleViewDtoList[0].panelId;
        }

        return this.http.post(
            environment.BASE_URL_HRD + 'tmMng/inviteSteeringCommitteeUser',
            payload
        );
    }

    addAndInviteHLEPMember(payload) {
        // payload.panelTypeCodeId = +localStorage.getItem("TEAM_CODE")
        if (payload.rgaRoleViewDtoList[0].panelId) {
            payload.disciplinaryPanelId = payload.rgaRoleViewDtoList[0].panelId;
            delete payload.rgaRoleViewDtoList[0].panelId;
        }
        if (!payload.disciplinaryPanelId) {
            delete payload.rgaRoleViewDtoList[0].panelId;
        }

        return this.http.post(
            environment.BASE_URL_HRD + 'tmMng/inviteHlepUser',
            payload
        );
    }

    saveColumnStateByResourceId(payload) {
        return this.http.post(
            environment.BASE_URL_HRD + 'rga/saveRgaColumnStateInfo',
            payload
        );
    }

    resetColumnStateByStateInfo(stateId) {
        return this.http.get(
            environment.BASE_URL_HRD + 'rga/resetRgaColumnStateInfo/' + stateId
        );
    }

    //  getColumnStateByResourceId(resourceId,rgaGrantConfigId,childResourceId?): Observable<any> {
    //    if(childResourceId){
    //     return this.http.get(environment.BASE_URL_HRD + 'rga/getRgaColumnStateInfo/' + resourceId + '/' + childResourceId + '/' + rgaGrantConfigId )

    //    }
    //    else{
    //     return this.http.get(environment.BASE_URL_HRD + 'rga/getRgaColumnStateInfo/' + resourceId + '/' + rgaGrantConfigId)

    //    }
    //   }
    getColumnStateByResourceId(resourceId, childResourceId?): Observable<any> {
        if (childResourceId) {
            return this.http.get(
                environment.BASE_URL_HRD +
                'rga/getRgaColumnStateInfo/' +
                resourceId +
                '/' +
                childResourceId
            );
        } else {
            return this.http.get(
                environment.BASE_URL_HRD + 'rga/getRgaColumnStateInfo/' + resourceId
            );
        }
    }

    public searchDasEmbassyData(payload): Observable<any> {
        return this.http.post(environment.BASE_URL_DAS + 'das/searchDasEmbassyApplications', payload);
    }

    public getFppRgaReviewConfigByGrantConfig(grantConfigId): Observable<any> {
        let grantConfigurationId = grantConfigId ? grantConfigId : 0;

        return this.http.get(
            environment.BASE_URL_HRD +
            'rga/getFppRgaReviewConfigByGrantConfig/' +
            grantConfigurationId
        );
    }

    // public getGrantList(batchId): Observable<any> {
    //   return this.http.get(environment.BASE_URL_HRD + 'rga/getRgaGrantConfigByBatchId/' + batchId)
    // }

    // public getPanelMembersDropdown(grantId, applicationId) {
    //   return this.http.get(environment.BASE_URL_HRD + 'rga/getPanelDetails/' + grantId)
    // }






    public openConditionalErrorsWithHTML(title?, msg?) {
        return this.conditionalErrorModalService
            .showModalWithCustomHTML(title, msg)
            .then(res => {
                // window.scroll(0, 0);
            })
            .catch(err => {
                // window.scroll(0, 0);
            });
    }

    public openFormSubmissionWarningModal(title?, msgs?) {
        return this.formSubmModalService
            .openWarningModal(
                title || 'Warning',
                msgs || [],
                'Agree & Submit',
                'Edit Application'
            )
            .then(confirmed => {
                if (confirmed == true) {
                    return true;
                } else {
                    return false;
                }
            })
            .catch(e => { });
    }

    public reportPreviewService(payload, reportType): Observable<any> {
        let reportGenerationType = reportType ? reportType : 'RGA_ApplicationForm'
        let headers = new HttpHeaders();
        let httpOptions = { headers: headers, cache: false, withCredentials: true };
        try {
            return this.http.post(
                environment.BASE_URL_COMMON +
                'cmn/reportGeneration/RND/' + reportGenerationType + '/pdf',
                payload,
                httpOptions
            );
        } catch (exception) {
            console.log(exception);
        }
    }

    public reportPreviewServicePDFP(payload): Observable<any> {
        let headers = new HttpHeaders();
        let httpOptions = { headers: headers, cache: false, withCredentials: true };
        try {
            return this.http.post(
                environment.BASE_URL_COMMON +
                'cmn/reportGeneration/HRD/PDFP_ApplicationForm/pdf',
                payload,
                httpOptions
            );
        } catch (exception) {
            console.log(exception);
        }
    }

    public getFilterArray(grantConfigId): Observable<any> {
        let grantConfigurationId = grantConfigId ? grantConfigId : 0
        return this.http.get(environment.BASE_URL_HRD + 'rga/getFilterDetails/' + grantConfigurationId)
    }

    public getFilterResources(grantConfigId): Observable<any> {
        let grantConfigurationId = grantConfigId ? grantConfigId : 0
        return this.http.get(environment.BASE_URL_HRD + 'rga/getFilterResources/' + grantConfigurationId)
    }


    public getPOReviewTypeService(grantConfigId): Observable<any> {
        let grantConfigurationId = grantConfigId ? grantConfigId : 0

        return this.http.get(environment.BASE_URL_HRD + 'rga/getPORgaReviewConfigByGrantConfig/' + grantConfigurationId)
    }

    getProjectsForEvaluation(configId) {
        return this.http.get(
            environment.BASE_URL_HRD + 'rga/getProjectForPanelEvaluation/' + configId
        );
    }

    public getProjectDetails(configId) {
        return this.http.get(
            environment.BASE_URL_HRD + 'rga/getProjectForReview/' + configId
        );
    }

    public sharedRgaDropdownList(configId) {
        return this.http.get(
            environment.BASE_URL_HRD + 'rga/getRgaDropDownList/' + configId
        );
    }

    public getRgaReviewConfig(projectAssignmentId) {
        return this.http.get(
            environment.BASE_URL_HRD +
            'rga/getRgaStage2Details/' +
            projectAssignmentId
        );
    }

    public sendBackToAssigner(payload) {
        return this.http.post(
            environment.BASE_URL_HRD + 'rga/sendBackToAssigner',
            payload
        );
    }

    public rejectApplicationBack(payload) {
        return this.http.post(
            environment.BASE_URL_HRD + 'rga/rejectRgaApplication',
            payload
        );
    }


    public openPopupDialog(title?, msg?, popupType?, btnOkText?) {
        return this.popupModelService
            .confirm(
                title || 'Please confirm',
                msg || 'Do you really want to reset form?',
                popupType || 'error',
                btnOkText || 'OK'
            )
            .then((confirmed) => {
                return confirmed;
            })
            .catch((e) => { });


    }

    public uploadVerification(payload): Observable<any> {
        return this.http.post(environment.BASE_URL_DES + 'desfAdmin/uploadVerification', payload)
    }

    public getCommentsHistory(applicationId, acronym): Observable<any> {
        return this.http.get(environment.BASE_URL_DAS + `${acronym}Admin/getDecisionHistory/${applicationId}`)
    }

    // OLD CODE
    public getDocumentList(payload): Observable<any> {
        return this.http.post(environment.BASE_URL_COMMON + 'attachment/getDocumentByAppIdAndAcronym', payload)
    }
    // new code
    public getDocumentListForScrutiny(payload, profileId: any): Observable<any>{
        return this.http.post(
        //   environment.BASE_URL_PCD +  `api/das/app/docs/all-files?profileId=${profileId}`,
        environment.BASE_URL_PCD +  `api/das/app/docs/all-files`,
          this.toFormData(payload)
        )
      }
      private toFormData(payload: any): FormData {
        if (payload instanceof FormData) {
          return payload;
        }
    
        const formData = new FormData();
        const source = payload && payload.data ? payload.data : (payload || {});
    
        Object.keys(source).forEach((key) => {
          const value = source[key];
          if (value === undefined || value === null) {
            return;
          }
          if (value instanceof File) {
            formData.append(key, value, value.name);
          } else if (value instanceof Blob) {
            formData.append(key, value);
          } else {
            formData.append(key, String(value));
          }
        });
    
        // Backward compatibility for existing callers that still pass `acronym`.
        if (source && source.acronym && !source.processAcronym) {
          formData.append('processAcronym', String(source.acronym));
        }
    
        return formData;
      }

    public getAdminDocs(acronym, appId): Observable<any> {
        return this.http.get(environment.BASE_URL_DES + `${acronym.toLowerCase()}Admin/listAdminFiles/` + appId)
    }
    public downloadAdminDocs(acronym, appId, fileName): Observable<any> {
        return this.http.get(environment.BASE_URL_DES + `${acronym.toLowerCase()}Admin/downloadAdminFile/${appId}/${fileName}`, { responseType: 'blob' })
    }
    public getVerificationFiles(appId): Observable<any> {
        return this.http.get(environment.BASE_URL_DES + 'desfAdmin/listFiles/' + appId)
    }
    public uploadDasDocument(payload, title): Observable<any> {
        return this.http.post(environment.BASE_URL_DAS + `das//uploadExcel/${title}`, payload)
    }

    public uploadDasDHDocument(payload): Observable<any> {
        return this.http.post(environment.BASE_URL_DAS + 'das//uploadExcel/DH', payload)
    }

    //   public uploadAdminDocument(acronym,appId,fileName,payload): Observable<any>{
    //     let headers = new HttpHeaders();
    //       headers = headers.append('Content-Type', 'multipart/form-data');
    //       let httpOptions = { headers: headers };
    //       return this.http.post(environment.BASE_URL_DES+`${acronym.toLowerCase()}Admin/uploadAdminFiles/${appId}/${fileName}`,payload,{headers: headers})
    //       //return this.http.post(environment.BASE_URL_COMMON+'attachment/uploadDocument',payload)
    //     }

    public getAttachmentDesfAdmin(appId, fileName): Observable<any> {
        return this.http.get(environment.BASE_URL_DES + `desfAdmin/downloadFile/${appId}/${fileName}`, { responseType: 'blob' })
    }
    public uploadDocument(payload): Observable<any> {
        return this.http.post(environment.BASE_URL_COMMON + 'attachment/uploadDocument', payload)
    }

    public uploadAdminDocument(acronym, appId, fileName, payload): Observable<any> {
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'multipart/form-data');
        let httpOptions = { headers: headers };
        return this.http.post(environment.BASE_URL_DES + `${acronym.toLowerCase()}Admin/uploadAdminFiles/${appId}/${fileName}`, payload, { headers: headers })
        //return this.http.post(environment.BASE_URL_COMMON+'attachment/uploadDocument',payload)
    }

    public getAttachmentByDocumentId(payload) {
        return this.http.post(environment.BASE_URL_COMMON + 'attachment/getAttachmentByDocumentId', payload)
    }

    public deleteDocument(payload): Observable<any> {
        return this.http.post(environment.BASE_URL_COMMON + 'attachment/deleteByDocumentId', payload)
    }

    public saveFile(base64, fileData, fileType) {
        const base_64 = base64.substring(base64.indexOf(',') + 1);
        const contentType = fileType;
        const fileName = fileData.fileName ? fileData.fileName : fileData.title;
        const fileExt = '.' + contentType.substring(contentType.indexOf('/') + 1);

        const blob = CommonHelper.base64toBlob(base_64, contentType);
        const blobUrl = URL.createObjectURL(blob);

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, fileName + fileExt);
        }
        else {
            let a = document.createElement('a');
            a.href = blobUrl;
            a.download = fileName + fileExt;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }
    }

















    public getCountryByDialingCodeDAS(
        countryId,
        countryDialingCode
    ): Observable<any> {
        return this.http.get(
            environment.BASE_URL_COMMON +
            'cmn/getCountryByDialingCodeAndCountryCode/' +
            countryId +
            '/' +
            countryDialingCode
        );
    }





    public getEmploymentListData(): Observable<any> {
        return this.http.get(
            environment.BASE_URL_PROFILE + 'profile/getProfileFormData'
        );
    }


    public saveEmploymentDetails(payload): Observable<any> {
        return this.http.post(
            environment.BASE_URL_PROFILE + 'profile/saveEmploymentDetails',
            payload
        );
    }

    /**
     * PROFILE SERVICES :END
     */

    public getCampus(universityId): Observable<any> {
        let headers = new HttpHeaders();
        let httpOptions = { headers: headers, cache: false, withCredentials: true };
        try {
            return this.http.get(
                environment.BASE_URL_COMMON +
                'cmn/getCampusByUniversityId/' +
                universityId,
                httpOptions
            );
        } catch (exception) {
            console.log(exception);
        }
    }

    public getDepartment(campusId): Observable<any> {
        let headers = new HttpHeaders();
        let httpOptions = { headers: headers, cache: false, withCredentials: true };
        try {
            return this.http.get(
                environment.BASE_URL_COMMON +
                'education/getDepartmentByCampusId/' +
                campusId,
                httpOptions
            );
        } catch (exception) {
            console.log(exception);
        }
    }

    getTaskTrackingByCommonProfile(): Observable<any> {
        return this.http.get(environment.BASE_URL_RPT + 'rpt/getAdminTaskTracking');
    }



    public markFormsTouched(form): void {
        CommonHelper.markFormGroupTouched(form);
    }

    public validate(f): boolean {
        if (f.status === 'VALID') {
            return true;
        }
    }

    public checkMaintenance(): Observable<any> {
        return this.http.get(
            "https://eservices.hec.gov.pk/assets/json/isLive.json"
        );
    }
    public pcdSaveApplication(payload): Observable<any> {
        return this.http.post(
            environment.BASE_URL_PCD + "api/pcd/application",
            payload
        );
    }
    public setPCDApplicationId(applicationId) {
        this.pcdAppId = applicationId;
    }
    public async getPCDApplicationId() {
        return this.pcdAppId;
    }
}